'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:QuotationCtrl
 * @description
 * # QuotationCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('QuotationCtrl', ['$scope', 'Quotation', 'Pagination', 'ProductCatalog',
   function($scope, Quotation, Pagination, ProductCatalog) {
    const SEARCH_ATTRIBUTES = {
      'search': '',
      'by_column': {
        'column': 'created_at',
        'order': 'desc'
      },
      'by_status': [],
      'by_product': [],
      'filters': {
        'contact_name': 'fa-sort',
        'prospect_id': 'fa-sort',
        'product_catalog_id': 'fa-sort',
        'created_at': 'fa-sort-desc',
        'state': 'fa-sort'
      }
    };
    $scope.filters = {}

    $scope.search = SEARCH_ATTRIBUTES;
    $scope.productList = [];
    $scope.selectedProduct = {};

    $scope.quotation = {
      list: [],
      pager: {}
    };


    $scope.getPage = (page) => {
      let params = {
        params: {
          page: page,
          per_page: 10,
          search: $scope.search.search,
          by_column: $scope.search.by_column,
          by_product: JSON.stringify($scope.search.by_product),
          by_status: JSON.stringify($scope.search.by_status)
        }
      };
      Quotation.index(params).then((response) => {
        $scope.quotation.list = response.data.quotations;
        $scope.quotation.pager = Pagination.GetPager(
          response.data.meta.pagination.total_objects,
          page,
          response.data.meta.pagination.per_page);
      }, (error) => {
        Quotation.error(error);
      });
    };

    $scope.clearSearch = () => {
      $scope.search = SEARCH_ATTRIBUTES;
      $scope.search.search = '';
      $scope.getPage(1);
    }

    $scope.filter = (column) => {
      let order = '';
      angular.forEach($scope.search.filters, (value, key) => {
        if(column === key) {
          if($scope.search.filters[key] === 'fa-sort-desc') {
            $scope.search.filters[key] = 'fa-sort-asc';
            order = 'ASC';
          } else {
            $scope.search.filters[key] = 'fa-sort-desc';
            order = 'DESC';
          }
        } else {
          $scope.search.filters[key] = 'fa-sort';
        }
      });
      $scope.search.by_column = {
        column: column,
        order: order
      };
      $scope.getPage(1);
    };

    $scope.addFilter = (by_filter, filter_type) => {
      const filterToBeAdded = $scope[filter_type]
      // TODOS selected
      if(filterToBeAdded.id === '') {
        $scope.search[by_filter] = []
        Object.keys($scope.filters).forEach((filter) => {
          if($scope.filters[filter].by_filter === by_filter)
            delete $scope.filters[filter]
        });
        $scope.filters = {}
      }
      else if(!$scope.search[by_filter].includes(filterToBeAdded.id)) {
        $scope.search[by_filter].push(filterToBeAdded.id);
        $scope.filters[filterToBeAdded.id] = {
          filter_type: filter_type,
          by_filter: by_filter,
          id: filterToBeAdded.id,
          name: filterToBeAdded.name
        }
      }
      $scope.getPage(1);
    };

    $scope.removeFilter = (id) => {
      const filterToBeRemoved = $scope.filters[id];
      if(filterToBeRemoved) {
        $scope.search[filterToBeRemoved.by_filter].forEach((filter, index, obj) => {
          if(filter === id) {
            obj.splice(index, 1);
          }
        })
        delete $scope.filters[id];
      }
      if(Object.keys($scope.filters).length < 1) {
        $scope.selectedProduct = $scope.productList[0];
        $scope.selectedStatus = $scope.statusList[0];
      }
      $scope.getPage(1);
    };

    $scope.deleteQuotation = (quotation) => {
      var index = $scope.quotation.list.indexOf(quotation);
      Quotation.delete(quotation.id).then(() => {
        $scope.quotation.list.splice(index, 1);
      }, (error) => {
        Quotation.error(error);
      });
    };

    const getAllParams = () => {
      const productPromise = ProductCatalog.index({params: {per_page: 'all', by_column: {"column": "name", "order": "ASC"}}}).then((response) => {
        $scope.productList = response.data.products;
        $scope.productList.unshift({name: "TODOS", id: ''});
        $scope.selectedProduct = $scope.productList[0];

        return;
      }).catch((error) => {
        // TODO: Show the notification that the clients were unable to get
        console.log(error);
      });

      const statusPromise = Quotation.getStates().then((response) => {
        $scope.statusList = response.data;
        $scope.statusList.unshift({name: "TODOS", id: ''});
        $scope.selectedStatus = $scope.statusList[0];

        return
      }).catch((error) => {
        console.log(error);
      });

      return Promise.all([productPromise, statusPromise]);
    }

    // START MAIN
    getAllParams().then((res) => {
      $scope.pager = {};
      $scope.getPage(1);
    })
    .catch((err) => {
      console.log(err);
    });
  }]);
